import React, { Component } from "react";
import lang from "../../lang/index";
import { Grade, ImageView , Gender, OfficialAuth} from "../../component/user-ui";
import Observer from '../../lib/observer';

class ListItem extends Component {
    static defaultProps = {
        item: {},
        onClick: function(){},
        showList: ['username','gender', 'grade', 'roomTitle']
    };

    constructor(props) {
        super(props);
    }

    jumpProfile(item) {
        hashHistory.push("/living/"+longToString(item.uid)+"/"+longToString(item.roomId));
        this.props.onClick();
    }

    render() {
        let item = this.props.item;

        return (
            <li data-uid={item.uid} key={item.uid}>
                <div className="list-item" onClick={() => this.jumpProfile(item)} key={item.roomUid}>
                    <div className="avatar">
                        <Observer>{isVisible => <ImageView src={item.avatar} lazyload={true} size={50} circle isVisible={isVisible} />}</Observer>
                        { item.officialAuth > 0 ? <OfficialAuth value={item.officialAuth}/> : null }
                    </div>
                    <div className="refbox">
                        <div className="user">
                        {
                            this.props.showList.map((key, index)=>{
                                if (key == 'gender') {
                                    return  item.gender ? <Gender key="gender" value={item.gender}/> : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? <Grade key="grade" value={item.grade}/> : null;
                                }

                                return (
                                    <div key={index} className={key}>{item[key]}</div>      
                                );
                            })
                        }
                        </div>
                    </div>
                    <div className="voice-box">
                         <div className="live">
                            <i className='live-img'></i>
                            <em></em>
                         </div>
                    </div>
                </div>
            </li>
        );
    }
}

export default ListItem;



// WEBPACK FOOTER //
// ./js/header/follow/host-item.js